import { sdk } from '../sdk';

export interface IncomeDepartment {
  _id: string;
  name: string;
  code?: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIncomeDepartmentData {
  name: string;
  code?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export interface UpdateIncomeDepartmentData {
  name?: string;
  code?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export interface IncomeDepartmentResponse {
  success: boolean;
  data: IncomeDepartment;
}

export interface IncomeDepartmentsResponse {
  success: boolean;
  data: IncomeDepartment[];
}

export const IncomeDepartmentsAPI = {
  async getAllIncomeDepartments(): Promise<IncomeDepartment[]> {
    const response = await sdk.client.get('/api/v1/income-departments');
    return response.data || response;
  },

  async getActiveIncomeDepartments(): Promise<IncomeDepartment[]> {
    const response = await sdk.client.get('/api/v1/income-departments/active');
    return response.data || response;
  },

  async getIncomeDepartmentById(id: string): Promise<IncomeDepartment> {
    const response = await sdk.client.get(`/api/v1/income-departments/${id}`);
    return response.data || response;
  },

  async getDepartmentTypes(id: string): Promise<any[]> {
    const response = await sdk.client.get(`/api/v1/income-departments/${id}/types`);
    return response.data || response;
  },

  async setDepartmentTypes(id: string, typeIds: string[]): Promise<{ success: boolean; data: any[] }> {
    const response = await sdk.client.put(`/api/v1/income-departments/${id}/types`, { typeIds });
    return response.data || response;
  },

  async createIncomeDepartment(data: CreateIncomeDepartmentData): Promise<IncomeDepartmentResponse> {
    const response = await sdk.client.post('/api/v1/income-departments', data);
    return response.data || response;
  },

  async updateIncomeDepartment(id: string, data: UpdateIncomeDepartmentData): Promise<IncomeDepartmentResponse> {
    const response = await sdk.client.put(`/api/v1/income-departments/${id}`, data);
    return response.data || response;
  },

  async deleteIncomeDepartment(id: string): Promise<{ success: boolean; message: string }> {
    const response = await sdk.client.delete(`/api/v1/income-departments/${id}`);
    return response.data || response;
  },
};
